<template>
  <div>
    <van-popup
      v-model="isShow"
      position="bottom"
      round
      lock-scroll
      close-on-popstate
      class="BaggageExplain"
      :style="{
        width: '100%',
        height: height
      }"
      :get-container="getContainer"
    >
      <ld-header
        :title="$t('J244', '行李说明')"
        @click-left="isShow = false"
      />
      <div class="check-box">
        <h3 class="font16">
          {{ value.vehiclesDesc || value.vehicleTypeDesc }}
        </h3>
        <p>
          最多容纳乘客
          <van-icon name="cross" /> 
          <span class="font16 font-bold">{{ value.personNo || value.personNum }}</span>
          &nbsp;&nbsp; 

          24寸以下行李
          <van-icon name="cross" /> 
          <span class="font16 font-bold">{{ value.luggageNo || value.luggageNum }}</span>
        </p>

        <van-image :src="require('Assets/images/car/baggage.png')" />

        <h3 class="font16">
          行李计算
        </h3>
        <div class="font12">
          <p>1.行李大小计算标准为24寸行李箱。</p>
          <p>2.超过24寸的大行李箱，计为2件。</p>
        </div>

        <h3 class="font16">
          温馨提示
        </h3>
        <div class="font12">
          <p>根据实际出行人数为您匹配合适车型，婴儿/儿童算一人，携带行李禁止超过容量限制，以免车辆空间不足无法服务。如发生此类情况，司机可拒绝服务，由乘客自行承担后果。</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup, Toast, Image } from 'vant'

export default {
  name: 'BaggageExplain',
  components: {
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Image.name]: Image,
  },
  data() {
    return {
      isShow: false
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    height: {
      type: String,
      default: '100%'
    },
    visibility: {
      type: Boolean,
      default: false
    },
    element:{
      type: String,
      default: ''
    }
  },
  methods: {
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if(this.element){
        return document.querySelector(this.element)
      }
      return ''
    },
  },
  watch: {
    visibility (val) {
      this.isShow = val
    },
    isShow (val) {
      this.$emit('update:visibility', val)
    }
  }
}
</script>

<style lang="less">
.BaggageExplain {
  h3 {
    margin: 5px 0;
  }

  .pad8 {
    padding: 8px;
  }

  .check-box {
    min-height: 50vh;
    height: auto;
    padding-bottom: 30px;
    padding: 10px;
  }
}
</style>